import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Clock, AlertTriangle } from 'lucide-react';

export const TrialBanner = () => {
  const { isTrial, trialDaysLeft, user } = useAuth();
  const navigate = useNavigate();

  // If not a trial user or if plan is free (expired), we either don't show or handle differently
  // If subscription is "free", it means trial expired.
  if (user?.subscription_plan === 'free') {
    return (
      <div className="bg-red-500 text-white px-4 py-2 text-center text-sm font-medium shadow-sm z-50 flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4" />
        Tu prueba gratuita ha expirado. Actualiza a PRO para seguir utilizando TallerMec Pro.
        <button 
          onClick={() => navigate('/subscription')}
          className="ml-3 bg-white text-red-600 px-3 py-1 rounded-md text-xs font-bold uppercase tracking-wider hover:bg-slate-100 transition-colors"
        >
          Ver Planes
        </button>
      </div>
    );
  }

  // Show trial banner only if isTrial is true
  if (!isTrial || trialDaysLeft === null) return null;

  let colorClass = "bg-amber-500 text-white";
  if (trialDaysLeft <= 3) {
    colorClass = "bg-orange-600 text-white";
  }

  return (
    <div className={`${colorClass} px-4 py-2 text-center text-sm font-medium shadow-sm z-50 flex items-center justify-center gap-2 flex-wrap`}>
      <Clock className="w-4 h-4" />
      <span>
        Prueba Gratuita: Quedan <strong>{trialDaysLeft} días</strong> para aprovechar al máximo.
      </span>
      <button 
        onClick={() => navigate('/subscription')}
        className="ml-3 bg-white text-amber-600 px-3 py-1 rounded-md text-xs font-bold uppercase tracking-wider hover:bg-slate-100 transition-colors shadow-sm"
      >
        Actualizar a PRO
      </button>
    </div>
  );
};
